import {generateUUID, hashStr} from "../utils/utils";

/// time after which an entry will be deleted from the cache in ms
const cacheTimeout = 500;

const requestBuffer = new Map<string, [Function, Function][]>();
const requestCache = new Map<string, Response>();

const resolveRequest = (callHash: string, error?: TypeError, response?: Response) => {
    if (!requestBuffer.has(callHash)) {
        return;
    }

    const requests = requestBuffer.get(callHash);
    requestBuffer.delete(callHash);

    if (error) {
        for (const request of requests) {
            request[1](error);
        }
    } else {
        if (response.ok) {
            requestCache.set(callHash, response);
            setTimeout(() => requestCache.delete(callHash), cacheTimeout);
        }

        for (const request of requests) {
            request[0](response.clone());
        }
    }
};

export function fetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
    let httpMethod;

    if (typeof input != 'string') {
        httpMethod = input.method;
    } else if (init?.method) {
        httpMethod = init.method;
    } else {
        httpMethod = 'GET';
    }

    return new Promise(((resolve, reject) => {
        const callHash = ['GET', 'OPTIONS', 'TRACE'].includes(httpMethod.toUpperCase())
            ? hashStr(JSON.stringify(input) + JSON.stringify(init ?? '{}')).toString()
            : generateUUID();

        // check if the hash exists in the buffer
        // this prevents several requests to the same resource to be fired in parallel
        // if yes: add promise to array and stop
        if (requestBuffer.has(callHash)) {
            requestBuffer.get(callHash).push([resolve, reject]);
            return;
        }
        // else check the cache for a result
        else if (requestCache.has(callHash)) {
            const response = requestCache.get(callHash);
            // the cache will only contain successful responses
            resolve(response);
            return;
        }
        // else create a new buffer entry and make the call
        else {
            requestBuffer.set(callHash, [[resolve, reject]]);
        }

        window.fetch(input, init)
            .then(response => resolveRequest(callHash, undefined, response))
            .catch(reason => resolveRequest(callHash, reason));
    }));
}
